export const VIEW = 'VIEW' as const;
export const FILTERING = 'FILTERING' as const;
export const SORTING = 'SORTING' as const;
export const COMPONENT_CREATED = 'COMPONENT_CREATED' as const;
export const COMPONENT_DELETED = 'COMPONENT_DELETED' as const;
export const COMPONENT_UPDATED = 'COMPONENT_UPDATED' as const;

export const FETCH_COMPONENTS_REASON = {
	VIEW,
	FILTERING,
	SORTING,
	COMPONENT_CREATED,
	COMPONENT_DELETED,
	COMPONENT_UPDATED,
} as const;

export type FetchComponentsReason =
	| typeof VIEW
	| typeof FILTERING
	| typeof SORTING
	| typeof COMPONENT_CREATED
	| typeof COMPONENT_DELETED
	| typeof COMPONENT_UPDATED;
